import {useCallback, useEffect, useMemo, useState} from 'react';

const useWindowDimensions = () => {

    const hasWindow = useMemo(() => typeof window !== 'undefined', []);

    const getWindowDimensions = useCallback(() => {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    }, [])

    const [windowDimensions, setWindowDimensions] = useState({width: 0, height: 0});

    useEffect(() => {
        const handleResize = () => {
            if (hasWindow) {
                setWindowDimensions(getWindowDimensions());
            }
        }

        handleResize()

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [hasWindow, getWindowDimensions]);

    return windowDimensions;
}


export default useWindowDimensions
